<template>
  <div class="news-swiper">
    <div class="news-wrapper">
      <div class="news-header">
        <h2>News</h2>
        <p>Professional underwater equipment supplying</p>
        <el-button class="learn-more" @click="$router.push('/news')">Learn More</el-button>
      </div>
      <swiper
        ref="mySwiper"
        :slidesPerView="3"
        :spaceBetween="125"
        :modules="modules"
        :grabCursor="true"
        :loop="true"
        :autoplay="{
          delay: 2000,
          disableOnInteraction: false
        }"
        class="mySwiper"
      >

        <swiper-slide v-for="item in newsList">
          <div class="news-card">
            <h3>{{ item.title }}</h3>
            <p class="info">
              {{ item.content }}
            </p>
            <!--<p class="time">{{ item.date }}</p>-->
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper';
import { newsSwipe } from "~/data/data";

const newsList = [
  ...newsSwipe,
  ...newsSwipe
]

const modules = [Autoplay]
</script>

<style lang="stylus" scoped>
.news-swiper
  max-width 1920px
  min-width 1280px
  height 580px
  margin 0 auto
  //background url("../assets/img/bg2.jpg") no-repeat
  background linear-gradient(-45deg, #f6fbfe,#31848a)
  .news-wrapper
    max-width 1510px
    min-width 1280px
    margin 0 auto
    padding 30px
    box-sizing border-box
    .news-header
      padding-top 50px
      color #FFF
      //color #333
      &>h2
        font-size 36px
        font-weight 300!important
      &>p
        font-size 16px
        font-weight 300
        margin-top 20px
      .learn-more
        float right
        margin-top -50px
        background #f5802b
        border none
        color #FFF
        padding 20px 30px
        font-size 16px
        &:hover
          opacity .8
    .mySwiper
      margin-top 60px
      .news-card
        width 400px
        height 260px
        background: #FFF
        border-radius 12px
        padding 30px 25px
        box-sizing border-box
        &>h3
          color #000
          font-weight 300
          font-size 18px
          margin-bottom 40px
          white-space nowrap
          text-overflow ellipsis
          overflow hidden
        .info
          font-size 16px
          line-height 24px
          margin-bottom 20px
          color #7f7f7f
          font-weight 300
          text-align left
        .time
          font-size 16px
          line-height: 24px;
          color: #02114b;
          font-weight: 300;
</style>
